import React, { useEffect, useRef } from "react";

import BilletSVG from "@payment/assets/BilletSVG";
import CreditCardSVG2 from "@payment/assets/CreditCardSVG2";
import PixSVG2 from "@payment/assets/PixSVG2";
import useCheckoutStepsOffersContext from "@payment/pages/CheckoutStepsOffers/provider";
import { useField } from "@unform/core";

import { Container, Label, PaymentMethodContainer, RadioInput } from "./styles";

const SelectPaymentMethods = () => {
  const { offer, methodPaymentSelected, setMethodPaymentSelected } =
    useCheckoutStepsOffersContext();

  const inputRefs = useRef<HTMLInputElement[]>([]);

  const {
    fieldName,
    registerField,
    defaultValue = "",
  } = useField("payment_method");

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRefs,
      getValue: (refs) => {
        return refs.current.find((input) => input?.checked)?.value;
      },
      setValue: (refs, id) => {
        const inputRef = refs.current.find((ref) => ref.id === id);
        if (inputRef) inputRef.checked = true;
      },
      clearValue: (refs) => {
        const inputRef = refs.current.find((ref) => ref.checked === true);
        if (inputRef) inputRef.checked = false;
      },
    });
  }, [fieldName, registerField]);

  const onClickContainer = (ref: HTMLInputElement) => {
    ref.click();
  };

  const onClick = (e: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
    const value = e.currentTarget.value;

    setMethodPaymentSelected(value);
  };

  const payment_methods = offer.offer.details.payment_methods;
  const columns = Object.values(payment_methods).filter(
    (value) => value === true,
  ).length;

  useEffect(() => {
    const [input] = inputRefs.current.filter(
      (ref) => ref.id === methodPaymentSelected,
    );

    input.click();
  }, [methodPaymentSelected]);

  return (
    <Container columns={columns}>
      {payment_methods.credit_card && (
        <PaymentMethodContainer
          type="button"
          active={payment_methods.credit_card}
          disabled={!payment_methods.credit_card}
          checked={methodPaymentSelected === "credit_card"}
          onClick={() => onClickContainer(inputRefs.current[0])}
        >
          <RadioInput
            type="radio"
            name={fieldName}
            id="credit_card"
            value="credit_card"
            ref={(ref) => (inputRefs.current[0] = ref)}
            defaultChecked={defaultValue.includes("credit_card")}
            onClick={onClick}
          />
          <CreditCardSVG2 />

          <Label htmlFor="checkout_steps">Cartão</Label>
        </PaymentMethodContainer>
      )}

      {payment_methods.boleto && (
        <PaymentMethodContainer
          type="button"
          active={payment_methods.boleto}
          disabled={!payment_methods.boleto}
          checked={methodPaymentSelected === "boleto"}
          onClick={() => onClickContainer(inputRefs.current[1])}
        >
          <RadioInput
            type="radio"
            name={fieldName}
            id="boleto"
            value="boleto"
            ref={(ref) => (inputRefs.current[1] = ref)}
            defaultChecked={defaultValue.includes("boleto")}
            onClick={onClick}
          />
          <BilletSVG />

          <Label htmlFor="checkout_steps">Boleto</Label>
        </PaymentMethodContainer>
      )}

      {payment_methods.pix && (
        <PaymentMethodContainer
          type="button"
          active={payment_methods.pix}
          disabled={!payment_methods.pix}
          checked={methodPaymentSelected === "pix"}
          onClick={() => onClickContainer(inputRefs.current[2])}
        >
          <RadioInput
            type="radio"
            name={fieldName}
            id="pix"
            value="pix"
            ref={(ref) => (inputRefs.current[2] = ref)}
            defaultChecked={defaultValue.includes("pix")}
            onClick={onClick}
          />
          <PixSVG2 />

          <Label htmlFor="checkout_steps">Pix</Label>
        </PaymentMethodContainer>
      )}
    </Container>
  );
};

export default SelectPaymentMethods;
